import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AutomationAgentsComponent } from '../Core/components/AutomationAgents/automation-agents.component';
import { AgentComponent } from '../components/Agent/agent.component';
import { AgentAnalyticsComponent } from '../components/AgentAnalytics/agent-analytics.component';
import { AgentDashboardComponent } from '../components/AgentDashboard/agent-dashboard.component';
import { AgentManagementComponent } from '../components/AgentManagement/agent-management.component';
import { AgentMentionsComponent } from '../components/AgentMentions/agent-mentions.component';
import { AutomationAgentsActivateGuard } from './guards/automation-agents-activate.guard';
import { AgentAnalyticsFilterResolver } from './resolvers/agent-analytics-filter.resolver';
import { AgentMentionsFilterResolver } from './resolvers/agent-mentions-filter.resolver';
import {
    AgentRouteSectionEnum,
    agentRoutePath,
    agentSectionSegments,
    automationAgentsRoutePath
} from './automation-agents-route.const';

const automationAgentsRoutes: Routes = [
    {
        path: automationAgentsRoutePath,
        component: AutomationAgentsComponent,
        canActivate: [AutomationAgentsActivateGuard],
        children: [
            {
                path: '',
                component: AgentManagementComponent,
                data: { title: 'AutomationAgents.browserTitle' }
            },
            {
                path: `${agentRoutePath}/:agent_id`,
                component: AgentComponent,
                data: { title: 'AutomationAgents.agent.browserTitle' },
                children: [
                    {
                        path: agentSectionSegments[AgentRouteSectionEnum.dashboard],
                        component: AgentDashboardComponent
                    },
                    {
                        path: agentSectionSegments[AgentRouteSectionEnum.mentions],
                        component: AgentMentionsComponent,
                        resolve: { filters: AgentMentionsFilterResolver }
                    },
                    {
                        path: agentSectionSegments[AgentRouteSectionEnum.analytics],
                        component: AgentAnalyticsComponent,
                        resolve: { agentFilter: AgentAnalyticsFilterResolver }
                    },
                    {
                        path: '',
                        redirectTo: agentSectionSegments[AgentRouteSectionEnum.dashboard],
                        pathMatch: 'full'
                    },
                    {
                        path: '**',
                        component: AgentDashboardComponent
                    }
                ]
            },
            {
                path: '**',
                component: AgentManagementComponent,
                data: { title: 'AutomationAgents.browserTitle' }
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(automationAgentsRoutes)
    ],
    exports: [
        RouterModule
    ],
    providers: [
        AutomationAgentsActivateGuard,
        AgentMentionsFilterResolver,
        AgentAnalyticsFilterResolver
    ]
})
export class AutomationAgentsRoutingModule { }
